import styled from 'styled-components'

export const ManagePickupTimesTable = styled.div`
  th.actions {
    text-align: right;
  }
  table th:last-child,
  table td:last-child {
    padding-right: 40px;
  }
  td.actions {
    > div {
      top: initial !important;
      float: right;
      margin-right: 10px !important;
    }
    svg {
      margin: 0 auto !important;
    }
  }
`
